import React from 'react';
import PropTypes from 'prop-types';
// icons
import { FaSearch } from 'react-icons/fa';
import { FaXmark } from "react-icons/fa6";

const LoupeButtonMobile = ({
  showSearchBar,
  isSticky,
  setShowSearchBar 
}) => {
  return (
    <span
      onClick={() => setShowSearchBar(!showSearchBar)}
      id="mobile-simple-search-btn"
      title="Mostrar/Ocultar barra búsqueda"
      className={`d-lg-none mobile-simple-search-btn ${isSticky ? 'd-block' : 'd-none'}`}
    >
      {!showSearchBar ? <FaSearch className={`icon-input fas search `} /> :
        <FaXmark className={`icon-input fas search `} />
      }
    </span>
  );
};

LoupeButtonMobile.propTypes = {
  showSearchBar: PropTypes.bool,
  isSticky: PropTypes.bool,
  setShowSearchBar: PropTypes.func
};

export default LoupeButtonMobile;
